module.exports = __webpack_public_path__ + "static/NewJune-semibold-4596714793a2691ac5ccebcbb5be46e5.woff2";